export default "__VITE_ASSET__gvGyuKuh__"